import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { CompanyList } from "../../apis/api/DirectoryApi";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import CommentModal from "../../Models/Buisnes_Impact/CommentModal";
import { useNavigate, useLocation } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";

const UserList = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const { CompanyData, loading } = useSelector((state) => state.DirectorySlice);
  console.log(CompanyData, "CompanyData");

  useEffect(() => {
    dispatch(CompanyList());
  }, [dispatch]);

  const handleViewClick = (company_id, userId) => {
    if (company_id && userId) {
      navigate("/OtherProfile", {
        state: { company_id, userId, from: location.pathname },
      });
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <div ></div>
      <div className="bg-white" style={{ overflowX: "auto", width: "100%" }}>
  <CustomTableWrapper
    data={CompanyData}
    itemsPerPage={10}
    enableSearch={true}
    searchKeys={["company_name", "company_email", "contact", "country"]}
    columns={[
      { label: "Company Logo", field: "company_logo" },
      { label: "Company Name", field: "company_name", sortable: true },
      { label: "Email", field: "company_email", sortable: true },
      { label: "Contact", field: "contact", sortable: true },
      { label: "Country", field: "country", sortable: true },
     
      { label: "Action", field: "action" },
    ]}
    renderRow={(item, index, currentPage, itemsPerPage) => (
      <tr key={index}>
        <td style={{ width: "80px", height: "50px", padding: "8px" }}>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #eee",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={item.company_logo?.replace("thumb/", "")}
              alt="Company Logo"
              style={{
                maxHeight: "75%",
                maxWidth: "75%",
                objectFit: "contain",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  process.env.PUBLIC_URL + "/company-logo-design.jpg";
              }}
            />
          </div>
        </td>
        <td>{item.company_name}</td>
        <td>{item.company_email}</td>
        <td>{item.contact}</td>
        <td>{item.country}</td>
       
        <td>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary me-1"
            onClick={() => handleViewClick(item.id, item.member_id)}
            title="View Profile"
          >
            <i className="bx bx-show"></i>
          </button>
        </td>
      </tr>
    )}
  />
</div>

    </>
  );
};

export default UserList;
